<template>
  <PersonalInformationComponent />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PersonalInformationComponent from "@/components/PersonalInformation/PersonalInformation.vue";

const componentName = "PersonalInformationRoute";

export default defineComponent({
  name: componentName,
  components: { PersonalInformationComponent },
});
</script>
